export const buttonSizes = ['tiny', 'small', 'normal', 'large', 'extraLarge'] as const;
export type ButtonSize = (typeof buttonSizes)[number];

export const buttonVariants = ['primary', 'secondary', 'tertiary', 'ghost'] as const;
export type ButtonVariant = (typeof buttonVariants)[number];

export const buttonIconPositions = ['left', 'right'] as const;
export type ButtonIconPosition = (typeof buttonIconPositions)[number];

export const buttonSizeTokens: Record<
  ButtonSize,
  { minHeight: number; paddingX: number; gap: number; fontSize: string; lineHeight: string; iconBox: number }
> = {
  tiny: { minHeight: 32, paddingX: 12, gap: 6, fontSize: '0.8125rem', lineHeight: '1rem', iconBox: 16 },
  small: { minHeight: 40, paddingX: 16, gap: 8, fontSize: '0.875rem', lineHeight: '1.125rem', iconBox: 18 },
  normal: { minHeight: 48, paddingX: 20, gap: 10, fontSize: '1rem', lineHeight: '1.25rem', iconBox: 20 },
  large: { minHeight: 52, paddingX: 22, gap: 10, fontSize: '1.0625rem', lineHeight: '1.375rem', iconBox: 22 },
  extraLarge: { minHeight: 56, paddingX: 24, gap: 12, fontSize: '1.125rem', lineHeight: '1.5rem', iconBox: 24 },
};
